import LoginSection from 'Components/Auth/Login';

import UADetector from 'Helper/UADetector';
import GuestLayout from 'Pages/_layout/Guest';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './LoginWithPasswordScreen.scss';

const LoginWithPasswordScreen = (): React.JSX.Element => {
    const { isAndroid } = UADetector();
    const viewportHeight = window?.visualViewport?.height ?? 0;
    const isSmallAndroidDevice = isAndroid && viewportHeight < 844;

    const [email, setEmail] = useState('');
    const { state } = useLocation();

    useEffect(() => {
        if (state?.email) {
            setEmail(state.email);
        }
    }, [state]);

    return (
        <GuestLayout
            showImage={false}
            classes={`${
                isSmallAndroidDevice ? 'small-android' : ''
            } login-page`}
            showClose={false}
            showLogo={true}
        >
            <div className="auth-section">
                <LoginSection
                    email={email}
                    isSmallAndroidDevice={isSmallAndroidDevice}
                />
            </div>
        </GuestLayout>
    );
};

export default LoginWithPasswordScreen;
